import { jsx as i } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { ButtonActionsLayout as c } from "./types.js";
import { BUTTON_ACTION_CLASSNAME as o, BUTTON_ACTION_CONTAINER_CLASSNAME as d } from "../constants.js";
import { ButtonVariant as a } from "../types.js";
/* empty css                   */
import { memo as A } from "../../../../external/preact/compat/dist/compat.module.js";
import { useMemo as N } from "../../../../external/preact/hooks/dist/hooks.module.js";
import T from "../Button.js";
function p({ actions: t, layout: s = c.BUTTONS_END }) {
  const n = () => `${o}--${s}`, l = (e) => {
    const r = t.length - 1;
    return e === r ? a.PRIMARY : a.SECONDARY;
  }, m = N(() => [...t].reverse(), [t]);
  return /* @__PURE__ */ i("div", { className: o, children: /* @__PURE__ */ i("div", { className: `${d} ${n()}`, role: "group", children: m.map((e, r) => /* @__PURE__ */ i(
    T,
    {
      "aria-label": e.title,
      disabled: e.disabled,
      variant: e.variant || l(r),
      onClick: e.event,
      state: e.state ?? "default",
      children: e.renderTitle ? e.renderTitle(e.title) : e.title
    },
    `${r}_${e.title || "0"}`
  )) }) });
}
const I = A(p);
export {
  I as default
};
